import React, { useState } from "react";

const DeleteRole = ({ roles, onRoleDelete }) => {
  const [selected, setSelected] = useState(null);

  return (
    <div className="flex justify-center w-full p-10">
      <div className="w-full max-w-2xl bg-white rounded-xl shadow-md p-8 border border-gray-200">
        <h2 className="text-2xl font-semibold text-gray-900 mb-4">Delete Role</h2>
        <p className="text-gray-600 mb-6">Select a role below and delete it permanently.</p>

        <div className="space-y-3">
          {roles.length === 0 ? (
            <p className="text-gray-500 text-center py-6">No roles available</p>
          ) : (
            roles.map((role) => (
              <div
                key={role}
                className={`flex justify-between items-center px-4 py-3 rounded-lg border 
                ${selected === role ? "border-orange-500 bg-orange-50" : "border-gray-300"}`}
              >
                <span className="font-medium text-gray-700">{role.slice(0, -1)}</span>

                <button
                  onClick={() => {
                    setSelected(role);
                    onRoleDelete(role);
                  }}
                  className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition"
                >
                  Delete
                </button>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default DeleteRole;
